const BlackGallery = (target) => {
  
  const initSlider = ($el, params) => {
    $el.slick(params);
  };

  const handleTroggleModal = (e) => {
    e.preventDefault();
    console.log('click')
    const $el = $(e.currentTarget);
    const imageSrc = $el.attr('data-modal-trigger');

    if ($('body').find('.modal').length) {
      $('body').find('.modal').remove();
    }
    
    // create modal and insert image
    const $modal = $(`
      <div class="modal">
        <button class="modal__close">
          <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.7 6.7c.39-.4.39-1.03 0-1.42 -.4-.4-1.03-.4-1.42 0l-5.3 5.29 -5.3-5.3c-.4-.4-1.03-.4-1.42 0 -.4.39-.4 1.02 0 1.41l5.29 5.29 -5.3 5.29c-.4.39-.4 1.02 0 1.41 .39.39 1.02.39 1.41 0l5.29-5.3 5.29 5.29c.39.39 1.02.39 1.41 0 .39-.4.39-1.03 0-1.42l-5.3-5.3 5.29-5.3Z"/></svg>
          <span class="sr-only">Fermer</span>
        </button>
        <div class="modal__content">
          <img src="${imageSrc}" alt="" />
        </div>
      </div>
    `);

    $('body').append($modal);
    $('body').addClass('modal-open');

    // bind close modal to button
    $modal.find('.modal__close').on('click', () => {
      $modal.remove();
      $('body').removeClass('modal-open');
    });

    // close on click outside
    $modal.on('click', (e) => {
      if (e.target === e.currentTarget) {
        $modal.remove();
        $('body').removeClass('modal-open');
      }
    });

    // close on escape
    $(document).on('keydown', (e) => {
      if (e.key === 'Escape') {
        $modal.remove();
        $('body').removeClass('modal-open');
      }
    });
  }

  const $images = $(target).find('[data-modal-trigger]') 

  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      const params = {
        slidesToShow: 1.2,
        arrows: false,
        dots: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 99999,
            settings: 'unslick',
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
            },
          },
        ],
      }
      initSlider($el, params);

      $images.on('click', handleTroggleModal);

      $(window).on('resize', () => {
        if (!$el.hasClass('slick-initialized')) {
          initSlider($el, params)
        }
      });
    });
}

export default BlackGallery;



// WEBPACK FOOTER //
// ./scripts/components/BlackGallery.js